import {
    Card, Table, TableBody, TableCell, TableContainer,
    TableHead, TablePagination, TableRow, Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { When } from "react-if";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { PaginatorFactory } from "../../factory";
import { ScheduleService } from "../../services/schedule.service";
import Loading from "../loading";
import NoData from "../no-data";
import ScheduleDisplay from "./scheduleDisplay";

export const ScheduleList = () => {
    const {
        selectedSchedule,
    } = useSelector((state: RootState) => state.schedule);
    const {
        pagination: { total, items },
        loading,
    } = useSelector((state: RootState) => state.schedule);

    const [pagination, setPagination] = useState<PaginatorFactory<any>>({
        page: 0,
        perPage: 25,
    });

    const usTimeZonesReadable: { [key: string]: string } = {}
    usTimeZonesReadable["America/New_York"] = 'Eastern Time'
    usTimeZonesReadable['America/Chicago'] = 'Central Time'
    usTimeZonesReadable['America/Denver'] = 'Mountain Time'
    usTimeZonesReadable['America/Los_Angeles'] = 'Pacific Time'

    useEffect(() => {
        ScheduleService.fetchMany(
            {
                ...pagination,
                page: pagination.page + 1,
            },
            (isValid, msg) => { }
        );
    }, [pagination?.perPage, pagination?.page]);

    return (
        <>
            <Card sx={{ mt: 2 }}>
                <TableContainer sx={{ position: "relative", overflow: "unset", maxHeight: 600 }}>
                    <Table sx={{ minWidth: 800 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Typography variant="body2" sx={{ color: "text.primary" }}>
                                        Team Name
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ color: "text.primary" }}>
                                        Start Day
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ color: "text.primary" }}>
                                        Timezone
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ color: "text.primary" }}>
                                        Created At
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ color: "text.primary" }}>
                                        Last Update Time
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ color: "text.primary" }}>
                                        Last Updated By
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {!loading.fetchMany &&
                                (items || []).map((item) => (
                                    <TableRow
                                        sx={{
                                            ":hover": {
                                                backgroundColor: "#F0F0F0",
                                                cursor: "pointer",
                                            },
                                        }}
                                        key={`schedule_${item._id}`}
                                        onClick={() => {
                                            ScheduleService.setSchedule(item);
                                        }}
                                    >
                                        <TableCell>
                                            <Typography variant="body2" sx={{ color: "text.primary" }}>
                                                {item.team?.name ?? ''}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ color: "text.primary" }}>
                                                {item.startDay}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ color: "text.primary" }}>
                                                {usTimeZonesReadable[item.timezone]}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ color: "text.primary" }}>
                                                {new Date(item.createdAt).toLocaleDateString()}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ color: "text.primary" }}>
                                                {new Date(item.updatedAt).toLocaleDateString()}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ color: "text.primary" }}>
                                                {item.updatedByWebAppUserName ?? "NA"}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>

                    <When condition={loading?.fetchMany}>
                        <Loading />
                    </When>

                    <When condition={!loading.fetchMany && items?.length < 1}>
                        <NoData
                            buttonText={null}
                            onClick={() => { }}
                            title={"No schedules found"}
                            description={"No schedules have been created."}
                        />
                    </When>
                </TableContainer>

                <TablePagination
                    rowsPerPageOptions={[25, 50, 100]}
                    component={"div"}
                    count={total ?? 0}
                    rowsPerPage={pagination?.perPage}
                    page={pagination?.page}
                    onPageChange={(e, p) => setPagination((pag) => ({ ...pag, page: p }))}
                    onRowsPerPageChange={(e) =>
                        setPagination((pag) => ({
                            ...pag,
                            perPage: parseInt(e.target.value, 10),
                        }))
                    }
                />
            </Card>
            {selectedSchedule && (
                <ScheduleDisplay
                    schedule={selectedSchedule}
                />
            )}

            {/* Schedule Details Modal (if needed) */}
            {/* Implement `ScheduleDrawer` if you want to display schedule details */}
        </>
    );
};
